import {NgModule} from "@angular/core";
import {QuillEditorComponent} from "./quill-editor.component";

@NgModule({
  declarations: [
    QuillEditorComponent,
  ],
  exports: [
    QuillEditorComponent,
  ],
})
export class QuillEditorModule {}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/ngx-quill-editor/quill-editor.module.ts